import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BsChevronLeft } from 'react-icons/bs';
import { setData } from '../../../core/redux/app/Actions';
import { CADASTRO_ITEMS } from '../../../core/constants/financial';
import TopbarDropdown from './TopbarDropdown';
import PeriodSelector from './PeriodSelector';
import CompanySelector from './CompanySelector';

const FinancialTopbar = ({
  companies,
  selectedCompany,
  changeCompany,
  onCadastroClick,
  onLancamentoClick,
  onResetClick,
  selectedPeriod,
  onPeriodChange,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.app.user || {});
  const company = useSelector((state) => state.app.company || {});
  const isSuperadmin =
    !!user?.isSuperAdmin || (company && company.type === 1);

  const goBack = () => {
    history.push('/home');
    dispatch(setData({ navigate: '/home' }));
  };

  return (
    <div className="fd-topbar">
      <div className="fd-topbar-title-group">
        <button className="fd-back-btn" type="button" onClick={goBack}>
          <BsChevronLeft />
        </button>
        <h2 className="fd-topbar-title">
          Dashboard <span>Financeiro</span>
        </h2>
      </div>
      <div className="fd-topbar-right">
        <PeriodSelector
          companyId={selectedCompany?.id}
          selectedPeriod={selectedPeriod}
          onChange={(item) => onPeriodChange && onPeriodChange(item)}
        />
        {isSuperadmin && onResetClick && (
          <button
            className="fd-btn-reset"
            type="button"
            onClick={onResetClick}
            title="Apaga todos os dados financeiros da empresa selecionada (apenas superadmin)"
          >
            RESET
          </button>
        )}
        <button className="fd-btn-add" type="button" onClick={onLancamentoClick}>LANÇAMENTO</button>
        <TopbarDropdown
          label="Cadastros"
          items={CADASTRO_ITEMS}
          onSelect={(item) => {
            if (onCadastroClick) onCadastroClick(item.key);
          }}
        />
        <CompanySelector
          companies={companies}
          selectedCompany={selectedCompany}
          changeCompany={changeCompany}
        />
      </div>
    </div>
  );
};

export default FinancialTopbar;
